export const mapPropsToValues = ({ celebrate_labels = [] }) => {
  const initialValues = {
    eventType: '',
    planType: '',
    guestNumber: '',
  };

  const celebrateValues = celebrate_labels.reduce((acc, current) => {
    acc[current.name] = current.value;
    return acc;
  }, {});

  return {
    ...initialValues,
    ...celebrateValues,
  };
};
